import React, { Component } from 'react';
import Carousel from 'react-slick';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Card } from '@material-ui/core';
import HOCSectionLoader from '../HOC/HOCSectionLoader';
import ContentLoader from 'react-content-loader';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';

const styles = {
    cardText: {
        margin: '10px',
        fontWeight: 'bold'
    }
};
class RecentlyViewed extends Component {
    componentDidMount() {
        this.getData();
    }
    getData = () => {
        this.props.recentListAction({
            limit: 5,
            day: new Date().getDay(),
            offset: new Date().getTimezoneOffset()
        });
    };
    renderLoading = () => {
        return (
            <div style={{ width: 250, margin: '10px', height: 250 }}>
                <ContentLoader
                    height={250}
                    width={250}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="250" height="250" />
                </ContentLoader>
            </div>
        );
    };
    render() {
        const {
            recentProviderList,
            recentProviderLoader,
            classes
        } = this.props;
        return (
            <HOCSectionLoader loading={recentProviderLoader}>
                <Card className=" provider-text-right">
                    <h5 className={classes.cardText}>
                        {' '}
                        <FormattedMessage
                            id="recently.title"
                            defaultMessage="Recently Viewed"
                        />
                    </h5>
                </Card>

                <Carousel autoPlay className="mt-2 provider-right-slider">
                    {recentProviderList.map(provider => {
                        if (provider.businessName) {
                            return (
                                <div key={provider.key}>
                                    <img
                                        alt={'provider'}
                                        src={provider.proImage.medium}
                                        width="350px"
                                        height="270px"
                                    />
                                    <p className="legend text-center">
                                        {provider.businessName}
                                    </p>
                                </div>
                            );
                        } else {
                            return this.renderLoading();
                        }
                    })}
                </Carousel>
            </HOCSectionLoader>
        );
    }
}
const mapStateToProps = ({ providers }) => {
    return {
        recentProviderList: providers.recentProviderList,
        recentProviderLoader: providers.recentProviderLoader
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(mapStateToProps, actions)
);
export default composedComponent(RecentlyViewed);



// WEBPACK FOOTER //
// ./src/components/Providers/RecentlyViewed.js